import { render } from "./Files.vue?vue&type=template&id=8c696824&scoped=true"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"

import "./Files.vue?vue&type=style&index=0&id=8c696824&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c696824"]])

export default __exports__